import React, { useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import { UploadFileComponent } from "../../../../data/DynamicTable/Modal";
import { useTheme } from "@emotion/react";
import { tokens } from "../../../../theme";
import { CloudUploadIcon } from "lucide-react";

function ReconFileUpload() {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [isGroup, setIsGroup] = useState(0);

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const handleOpenModal = (group = 0) => {
    setIsGroup(group);
    setDialogOpen(true);
  };

  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const roleGroupId = parseInt(decodedToken.RoleGroupId);

  return (
    <Box m="2px">
      <Box
        m="2px"
        sx={{
          justifyContent: "end",
          alignItems: "center",
          display: "flex",
        }}
      >
        <Typography style={{ color: colors.greenAccent[400], margin: "0 8px" }}>
          Upload Transactions for recon
        </Typography>
        <Button
          component="label"
          variant="contained"
          tabIndex={-1}
          startIcon={<CloudUploadIcon />}
          sx={{
            backgroundColor: colors.greenAccent[500],
            borderRadius: "4px",
            m: "10px",
          }}
          onClick={() => handleOpenModal(0)}
        >
          <Typography style={{ color: colors.primary[400], margin: "0 8px" }}>
            Upload
          </Typography>
        </Button>

        {roleGroupId === 1 && (
          <Button
            component="label"
            variant="contained"
            tabIndex={-1}
            startIcon={<CloudUploadIcon />}
            sx={{
              backgroundColor: colors.greenAccent[500],
              borderRadius: "4px",
              m: "10px",
            }}
            onClick={() => handleOpenModal(1)}
          >
            <Typography style={{ color: colors.primary[400], margin: "0 8px" }}>
              SMS Upload
            </Typography>
          </Button>
        )}
      </Box>

      <UploadFileComponent
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        isGroup={isGroup}
      />
    </Box>
  );
}

export default ReconFileUpload;